import type { Conf, DataLayerArg } from 'src/global';
import { addTags, disableChat, enableChat, setPendoChatDisplay, setSalesText } from 'src/util';
import waitForDepartment from 'src/waitForDepartment';

import changePendoText from './change-pendo-text';

const LIMIT_REACHED_EVENT = 'basic_limit_reached'; // When a free pubisher reached page count or doc size limitation
const LIMIT_PUBLISHED_REACHED_EVENT = 'basic_limit_published_reached'; // When a free pubisher reached publication limitation
const LIMIT_REACH_WAIT_DEPARTMENT = location.href.includes('test_limit_reach') ? 5000 : 15000;
const UPGRADE_EVENT = 'upgrade_modal_shown';

export const moveZdOutWindow = () => {
    const style = document.createElement('style');
    style.textContent = 'iframe#launcher {visibility: hidden;}';
    document.head.appendChild(style);
};

export const loadSalesInWorkspace = (conf: Conf) => {
    const detectGtmEvent = (event: string, callback: () => void) => {
        const dataLayerRef = window.dataLayer;
        const originalPush = dataLayerRef?.push;
        if (!dataLayerRef || !originalPush) {
            return;
        }
        dataLayerRef.push = (arg?: DataLayerArg) => {
            if (arg && 'event' in arg && arg?.event === event) {
                callback();
            }
            return originalPush.apply(dataLayerRef, [arg]);
        };
    };

    const switchChat = (isOnline: boolean) => {
        if (isOnline) {
            setPendoChatDisplay('block');
            changePendoText(isOnline, conf);
            enableChat(conf);

            // for reach limited free user
            setTimeout(() => {
                window.$zopim?.livechat.window.show();
            }, 400);
        } else {
            changePendoText(isOnline, conf);
            disableChat();
        }
    };

    const loadSalesForLimitReach = () => {
        addTags(['limit_reach'], conf);
        setSalesText();

        const timer = setTimeout(
            () => waitForDepartment(switchChat, conf.waitCount, conf),
            LIMIT_REACH_WAIT_DEPARTMENT,
        );
        detectGtmEvent(UPGRADE_EVENT, () => {
            clearTimeout(timer);
        });
    };

    const detectReachLimit = () => {
        const bannerText = document.querySelector<HTMLDivElement>(
            'div[class^="Notification__notification__message"]',
        )?.innerText;

        detectGtmEvent(LIMIT_REACHED_EVENT, loadSalesForLimitReach);
        // For the case when this script is loaded after GTM sent the event
        if (/your files exceeded the limits/.test(bannerText || '')) {
            window.dataLayer?.push({ event: LIMIT_REACHED_EVENT });
        }

        if (location.pathname.startsWith('/home/published')) {
            detectGtmEvent(LIMIT_PUBLISHED_REACHED_EVENT, loadSalesForLimitReach);
            // For the case when this script is loaded after GTM sent the event
            if (/reached the limit of \d published documents/.test(bannerText || '')) {
                window.dataLayer?.push({ event: LIMIT_PUBLISHED_REACHED_EVENT });
            }
        }
    };

    setPendoChatDisplay('none');
    detectReachLimit(); // trigger waitForDepartment
};

export default loadSalesInWorkspace;
